import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { CanvasService } from '../canvas.service';
import { ToolbarOriginType } from '../canvas.model';

@Component({
  selector: 'app-canvas-custom-action-dialog',
  templateUrl: './canvas-custom-action-dialog.component.html',
  styleUrl: './canvas-custom-action-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CanvasCustomActionDialogComponent {
  @ViewChild('toolbarInput') toolbarInput!: ElementRef;

  @Input() origin: string = ToolbarOriginType.BY_MOUSE_SELECTION;
  @Output() onSetToolbarChatEvent = new EventEmitter();
  @Output() onSendCanvasQueryEvent = new EventEmitter<string>();
  @Output() onApplyStyleEvent = new EventEmitter<string>();

  canvasQuery: string = '';
  shouldCanvasChatAvailable: boolean = false;

  constructor(public canvasService: CanvasService) {}

  ngOnInit() {
    this.shouldCanvasChatAvailable = false;
    this.canvasQuery = '';

    if (this.origin === ToolbarOriginType.BY_SECTION_TITLE_CLICK) {
      this.shouldCanvasChatAvailable = true;
      this.canvasQuery = '';
      this.focusToolbar();
    }
  }

  setToolbarChat() {
    this.shouldCanvasChatAvailable = true;
    this.canvasQuery = '';
    this.onSetToolbarChatEvent.emit();
    this.focusToolbar();
  }

  sendCanvasQuery() {
    this.onSendCanvasQueryEvent.emit(this.canvasQuery);
  }

  applyStyle(className: string) {
    this.onApplyStyleEvent.emit(className);
  }

  focusToolbar() {
    setTimeout(() => {
      if (this.toolbarInput) {
        this.toolbarInput?.nativeElement?.focus();
      }
    }, 500);
  }
}
